import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPen2Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#000"
      d="M4.168 15h3.533a.83.83 0 0 0 .592-.242l5.767-5.775 2.366-2.316a.833.833 0 0 0 0-1.184l-3.533-3.575a.834.834 0 0 0-1.183 0L9.36 4.267l-5.784 5.775a.83.83 0 0 0-.241.591v3.534a.833.833 0 0 0 .833.833m8.133-11.325 2.359 2.358-1.184 1.184-2.358-2.359zm-7.3 7.3 4.942-4.942 2.358 2.359-4.941 4.941H5zm12.5 5.692h-15a.833.833 0 1 0 0 1.666h15a.833.833 0 0 0 0-1.666M16.89 15h-2.495v-.525l.896-.906q.27-.278.434-.464.165-.188.24-.341a.74.74 0 0 0 .075-.33q0-.212-.12-.317a.45.45 0 0 0-.315-.108.9.9 0 0 0-.402.095 2 2 0 0 0-.408.272l-.41-.486q.153-.132.325-.25t.4-.187q.23-.075.55-.074.351 0 .602.127.255.127.39.347.138.218.138.493 0 .296-.118.54a2 2 0 0 1-.341.483q-.223.24-.537.53l-.46.432v.034h1.556z"
    />
  </svg>
);
export default SvgPen2Icon;
